// @flow
import {connect} from 'react-redux';
import Customize from '../components/Customize';
import {bindActionCreators} from 'redux';
import {actions as MyStoreActions} from '../duck';
import type {RootState} from '../../../../modules';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    user: state.auth.user,
    store: state.store.store,
    storeInformation: state.ui.storeInformation,
    isSaving: state.myStore.isSaving,
    error: state.myStore.error,
    saveStoreInformationSuccess: state.myStore.saveStoreInformationSuccess,
  }),
  (dispatch: Dispatch<any>) => bindActionCreators({...MyStoreActions}, dispatch)
)(Customize);
